module.exports = __webpack_public_path__ + "static/media/amazon.da095289.png";